import { Button, Group, SegmentedControl, Stack } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import ContactListsListing from "./ContactListsListing";
import { Link, useNavigate, useParams } from "react-router-dom";
import ContactListsListingFolder from "./ContactListsListingFolder";
import FoldersListing from "./FoldersListing";
import FolderAdder from "./FolderAdder";
import { useListStore } from "../../../../../stores/ListStore";
import { useLanguage } from "../../../../../stores/LanguageStore";

const LeftWrapperContacts = () => {
  const lang = useLanguage((s) => s.language);
  const { folderId } = useParams();

  const navigate = useNavigate();

  return (
    <Stack pos={"relative"} flex={1}>
      <Group mt={16} miw={430}>
        <SegmentedControl
          data={[
            {
              label: lang.prospects.tabs.lists,
              value: "lists",
            },
            {
              label: lang.prospects.my_folders,
              value: "folders",
            },
          ]}
          size="md"
          value={location.href.includes("folder") ? "folders" : "lists"}
          w={225}
          bg={"var(--mantine-color-primary-2)"}
          onChange={(v) => {
            navigate(
              v === "lists" ? "/contact-lists/" : "/contact-lists/folder"
            );
          }}
        />

        {folderId ? (
          <FolderAdder
            type={"ContactList"}
            onFinish={() => useListStore.getState().setListingLoad(true)}
            isButton
          />
        ) : (
          <Button
            leftSection={<IconPlus />}
            size="md"
            radius={"md"}
            fz={16}
            ml={"auto"}
            component={Link}
            to={"/contact-lists/import"}
          >
            {lang.prospects.create_list}
          </Button>
        )}
      </Group>

      {folderId ? (
        folderId === "none" ? (
          <FoldersListing />
        ) : (
          <ContactListsListingFolder />
        )
      ) : (
        <ContactListsListing />
      )}
    </Stack>
  );
};

export default LeftWrapperContacts;
